import React from 'react';

const RoomTypeOptions = ({
  activeRoomTypes,
  toggleRoomType,
  localisations,
}) => {
  const roomsActive = activeRoomTypes.includes('showme_rooms');
  const oneBedsActive = activeRoomTypes.includes('showme_1beds');
  const wholePropertiesActive = activeRoomTypes.includes(
    'showme_buddyup_properties',
  );
  return (
    <fieldset className="search_by__type">
      <legend className="search_by__search_title">
        {localisations.include}
      </legend>
      <ul>
        <li className="search_by__search_item">
          <input
            type="checkbox"
            id="input_showme_rooms"
            name="showme_rooms"
            checked={roomsActive}
            onChange={() => toggleRoomType('showme_rooms', roomsActive)}
          />
          <label htmlFor="input_showme_rooms">
            {localisations.rooms_in_exisiting_shares}
          </label>
        </li>
        <li className="search_by__search_item">
          <input
            type="checkbox"
            id="input_showme_1beds"
            name="showme_1beds"
            checked={oneBedsActive}
            onChange={() => toggleRoomType('showme_1beds', oneBedsActive)}
          />
          <label htmlFor="input_showme_1beds">
            {localisations.studios_1_beds}
          </label>
        </li>
        <li className="search_by__search_item">
          <input
            type="checkbox"
            id="input_showme_buddyup_properties"
            name="showme_buddyup_properties"
            checked={wholePropertiesActive}
            onChange={() =>
              toggleRoomType('showme_buddyup_properties', wholePropertiesActive)
            }
          />
          <label htmlFor="input_showme_buddyup_properties">
            {localisations.whole_properties}
          </label>
        </li>
      </ul>
    </fieldset>
  );
};
export default RoomTypeOptions;
